"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const change_case_1 = require("change-case");
exports.default = {
    camelCase: change_case_1.camelCase,
    capitalCase: change_case_1.capitalCase,
    constantCase: change_case_1.constantCase,
    dotCase: change_case_1.dotCase,
    headerCase: change_case_1.headerCase,
    noCase: change_case_1.noCase,
    paramCase: change_case_1.paramCase,
    pascalCase: change_case_1.pascalCase,
    pathCase: change_case_1.pathCase,
    sentenceCase: change_case_1.sentenceCase,
    snakeCase: change_case_1.snakeCase
};
//# sourceMappingURL=change-case.js.map